import { render } from "./CardLastCourses.vue?vue&type=template&id=613962ff&scoped=true"
import script from "./CardLastCourses.vue?vue&type=script&lang=js"
export * from "./CardLastCourses.vue?vue&type=script&lang=js"

import "./CardLastCourses.vue?vue&type=style&index=0&id=613962ff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613962ff"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
